import React, { useState, useEffect } from "react";
import { Button, TextInputField, Pane, EyeOpenIcon, EyeOffIcon, Tooltip, Position, InfoSignIcon } from "evergreen-ui";
import { useSelector } from "react-redux";

import styles from "../ForgetPassword/forgetPassword.module.css";
import {
  Captcha,
  generateString,
  validateCaptcha,
} from "../../Captcha/Captcha";
import { useNavigate } from "react-router-dom";
import { loadData, saveData } from "../../../Utils/localStorage";
import { ToastContainer, toast } from "react-toastify";
import { validatePassword } from "../../../Utils/Validation";
import { PRODUCT } from "../../../Utils/variables";
export const ChangePassword = () => {
  document.title = PRODUCT + " - Change Password";
  const { isLogin, vendorId } = useSelector((state) => state.auth);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassowrd, setConfirmPassword] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const [captcha, setCaptcha] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState({
    confirmPassword: false,
    newPassword: false,
  });
  const handleSubmit = () => {
    if (newPassword == "") {
      toast.error("Please enter new password");
    } else if (!validatePassword(newPassword).valid) {
      toast.error(validatePassword(newPassword).error);
    }else if (confirmPassowrd == "") {
      toast.error("Please enter  confirm new password");
    } else if (confirmPassowrd !== newPassword) {
      toast.error("new password and confirm new password not matched");
    } else if (!validateCaptcha(captcha, captchaValue)) {
      toast.error("Captcha not matched");
    } else {
      fetch(process.env.REACT_APP_API_URL + "/api/vendor/change_password", {
        method: "POST",
        body: JSON.stringify({
          email: loadData("forgotEmail") || "",
          key: loadData("key"),
          new_password: newPassword,
          confirm_new_password: confirmPassowrd,
        }),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          setCaptchaValue("");
          setCaptcha(() => generateString(6));
          if (res.status == true) {
            toast.success(`${res.message}`);
            saveData("forgotEmail", "");
            saveData("key", "");
            setTimeout(() => {
              navigate("/login");
            }, 2000);
          } else {
            toast.error(`${res.message}`);
          }
        })
        .catch((err) => console.log("e", err));
    }
  };
  const handleGenerateCaptcha = () => {
    setCaptcha(() => generateString(6));
  };
  useEffect(() => {
    if (isLogin) {
      navigate("/rfqs");
    }
  }, []);

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  return (
    <>
      <div className={styles.mainDivFP}>
        <div className={styles.topFP}>
          <h1>CHANGE PASSWORD</h1>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              textAlign: "left",
              border: "1px solid lightGrey",
              borderRadius: "0.5rem",
              backgroundColor: "#fbfafa",
              padding: "4vh 2vh",
            }}
          >
            <Pane className={styles.panecls}>
            <TextInputField
               type={showPassword.newPassword ?"text":"password"}
              label=
              {
                <>
                  New Password 
                  <Tooltip
                    content="The new password must be at least 8 characters long and include at least one uppercase letter, one number, and one special character (@$!%*?&). Avoid sequential patterns (like 1234 or abcd) and repeated characters (like 111 or aaa)."
                    position={Position.RIGHT}
                    appearance="card">
                    <span className={styles.tooltipspan}>
                      <InfoSignIcon icon="info-sign" color="primary" size={14} style={{zIndex:1}} />
                    </span>
                  </Tooltip>
                </>
               }
              placeholder="New Passowrd"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className={styles.inputDiv}
            />
            {showPassword.newPassword ? (
                  <EyeOpenIcon
                    className={styles.eyecommon}
                    onClick={() => togglePasswordVisibility("newPassword")}
                  />
              ) : (
                <EyeOffIcon
                  className={styles.eyecommon}
                  onClick={() => togglePasswordVisibility("newPassword")}
                />
              )}
            </Pane>
            <Pane className={styles.panecls}>
            <TextInputField
              type={showPassword.confirmPassword ?"text":"password"}
              label="Confirm New Password"
              placeholder="Confirm New Passowrd"
              value={confirmPassowrd}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className={styles.inputDiv}
            />
            {showPassword.confirmPassword ? (
                  <EyeOpenIcon
                    className={styles.eyecommon}
                    onClick={() => togglePasswordVisibility("confirmPassword")}
                  />
              ) : (
                <EyeOffIcon
                  className={styles.eyecommon}
                  onClick={() => togglePasswordVisibility("confirmPassword")}
                />
              )}
            </Pane>
            <TextInputField
              label="Captcha Code"
              placeholder="Enter Captcha Code"
              value={captchaValue}
              onChange={(e) => setCaptchaValue(e.target.value)}
              className={styles.inputDiv}
            />
            <div>
              <Captcha captcha={captcha} setCaptcha={setCaptcha} />
            </div>
            <div className={styles.instructionDivFP}>
              <p>
                Please enter the code shown in the above <br />
                text box.There are no zeros in the image.
              </p>
            </div>
            <div>
              <Button
                className={styles.nextBtnFP}
                onClick={handleSubmit}
                id="poppinFontLogin"
              >
                CHANGE PASSWORD
              </Button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </>
  );
};
